/*
Gummala Prakash 11/17/2022 3031593925 Fixed Button Responsiveness.
Raghu 02/27/2023 3031593925 fixed alignments
Prakash 03-23-23 3031593925 fixed alignments issue in account summary.
Sohel 05/26/2023 3031593925 Placement Date Issue
Gireesh 09/24/2023 5155351118 Removed Commented Code And Added Account Balance Field
*/
import React, {useEffect, useContext} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useForm} from 'react-hook-form';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {Controller} from 'react-hook-form';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {STATE} from '../../constants/Lookup';
import {fetchStateDropdown} from '../../redux/reducers/AdvanceSearch';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {SsnMaskCustom} from '../../util/SsnMaskFormat';
import {PhoneMaskCustom} from '../../util/PhoneMaskFormat';
import {ThemeContext} from '../../themes/ThemeProvider';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {positiveNumberOnly} from '../../util/Currency';
const SearchForm = ({setSearchedData, setAdvanceSearchData, setSubmit, setClear, clear}) => {
  const {dropDownData} = useSelector(({advanceSearch}) => advanceSearch);
  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    return label;
  };

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchStateDropdown());
  }, []);
  const initialValues = {
    placementDate: null,
    accNumber: '',
    firstName: '',
    lastName: '',
    phone: '',
    ssn: '',
    state: '',
    client: '',
    clientAccNumber: '',
    city: '',
    mrn: '',
  };
  const regx = /^\d+$/;

  const validationSchema = Yup.object().shape({
    placementDate: Yup.date().typeError('Invalid date format').nullable(),
    clientAccNumber: Yup.string().test(
      'clientAccNumber',
      'The field should have digits only',
      (value) => {
        if (value?.length > 0 && !regx.test(value)) {
          return false;
        } else {
          return true;
        }
      },
    ),
  });

  const onSubmit = (data) => {
    setSearchedData('');
    setAdvanceSearchData(data ? data : '');
    setSubmit(true);
  };
  const {register, handleSubmit, control, reset, errors} = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });
  const handleClear = () => {
    reset(initialValues);
    setClear(true);
  };


  return (
    <div className="mt-2 new-standard-textfields">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-row">
          <div className=" col-sm-4 col-md-4 col-lg-3 col-xl-3">
            <Controller
              render={({value, onChange}) => (
                <TextField
                  placeholder="Enter Account Number"
                  margin="dense"
                  className="custom-text-field"
                  fullWidth
                  value={value}
                  InputProps={{
                    inputComponent: positiveNumberOnly,
                  }}
                  variant="outlined"
                  label="Account Number"
                  onChange={(e) => onChange(e.target.value)}
                />
              )}
              control={control}
              name="accNumber"
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter First Name"
              margin="dense"
              name="firstName"
              variant="outlined"
              label="First Name"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter Last Name"
              margin="dense"
              name="lastName"
              variant="outlined"
              label="Last Name"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3  form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter SSN"
              margin="dense"
              name="ssn"
              variant="outlined"
              label="SSN"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              InputProps={{
                inputComponent: SsnMaskCustom,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3  form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter MRN"
              margin="dense"
              name="mrn"
              variant="outlined"
              label="MRN"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter Phone Number "
              margin="dense"
              name="phone"
              defaultValue=""
              variant="outlined"
              label="Phone Number"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              InputProps={{
                inputComponent: PhoneMaskCustom,
              }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3   form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter Client Code"
              margin="dense"
              name="client"
              variant="outlined"
              label="Client Code"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter Client Account Number"
              margin="dense"
              name="clientAccNumber"
              variant="outlined"
              label="Client Account Number"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
            <FormHelperText style={{color: 'red'}} variant="outlined">
              {errors.clientAccNumber?.message ? errors.clientAccNumber.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group invalid-errortext">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                name="placementDate"
                control={control}
                render={({value, onChange}) => (
                  <KeyboardDatePicker
                    label="Placement Date"
                    value={value}
                    className={`${classes.labelName}`}
                    format="MM/dd/yyyy"
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    maxDate={new Date()}
                    helperText={null}
                    autoOk
                    margin="dense"
                    inputVariant="outlined"
                    onChange={onChange}
                  />
                )}
              />
            </MuiPickersUtilsProvider>
            <FormHelperText style={{color: 'red'}} variant="outlined">
              {errors?.placementDate?.message ? errors?.placementDate?.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    classes={{
                      popper: classes.dropDown,
                      option: classes.option,
                    }}
                    {...props}
                    id="state"
                    options={getOptions(STATE)}
                    size="small"
                    getOptionDisabled={(option) => option.valueCode === null}
                    getOptionLabel={(option) => {
                      return option && option.valueCode && option.value ?
                        option.valueCode + ' - ' + option.value :
                        option.value === null ?
                          option.valueCode :
                          '';
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        className={` ${classes.labelName}`}
                        {...params}
                        variant="outlined"
                        fullWidth
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        label="State"
                        name="state"
                        placeholder="Select State"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="state"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-3 col-xl-3 form-group">
            <TextField
              className={` ${classes.labelName} form-textfield form-textfield-label`}
              placeholder="Enter City "
              margin="dense"
              name="city"
              variant="outlined"
              label="City"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              inputRef={register}
              fullWidth
            />
          </div>
        </div>
        <div className="row justify-content-center mb-2">
          <Button
            type={clear ? 'submit' : 'button'}
            variant="outlined"
            onClick={() => handleClear()}
            className={`mr-1 reset-btn ${classes.buttonRoot}`}
          >
            Clear
          </Button>
          <Button
            type="submit"
            variant="outlined"
            className={`ml-1 search-btn ${classes.buttonRoot}`}
          >
            Search
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SearchForm;
